import React from 'react';

import _ from "underscore";

import PropTypes from 'prop-types';

import MultiSelectFilter from './MultiSelectFilter';
import Select2 from './Select2';
import classNames from 'classnames';

// Sharks + ORabani - if you plan on changing/adding to the mode option labels, consider implementing a way to ensure they're consistent
// between the frontend and backend. ChangeHistory utilizes these labels to correctly label changes. See SignalChangeEventObserver.
const MODE_OPTIONS = [
  { id: "all", text: "All Campaigns" },
  { id: "whitelist", text: "Specific Campaigns" },
  { id: "blacklist", text: "All Campaigns Except..." }
];

const NONE_OPTION = { id: "none", text: "No Campaigns" };

class CampaignSelector extends React.Component {
  constructor(props) {
    super(props);

    let selectedCampaigns = [];
    if (!_.isUndefined(this.props.configurationModel.get('selected_campaigns'))) {
      selectedCampaigns = this.props.configurationModel.get('selected_campaigns');
    }

    let selectorMode = 'all';
    if (_.isUndefined(this.props.configurationModel.get('campaign_selector_mode'))) {
      this.props.configurationModel.set('campaign_selector_mode', selectorMode);
    } else {
      selectorMode = this.props.configurationModel.get('campaign_selector_mode');
    }

    this.state = {
      selectorMode: selectorMode,
      selectedCampaigns,
      initialRender: true
    };

    this.updateSelectedCampaigns = this.updateSelectedCampaigns.bind(this);
  }

  updateSelectorMode(data) {
    if (this.state.selectorMode !== data.id) {
      this.props.configurationModel.set('campaign_selector_mode', data.id);
      this.setState({ selectorMode: data.id, initialRender: false });
    }
  }

  updateSelectedCampaigns(data) {
    let selectedCampaigns = _.map(data, function(campaignData) {
      return campaignData.id;
    });
    this.props.configurationModel.set('selected_campaigns', selectedCampaigns);
    this.setState({ selectedCampaigns: selectedCampaigns });
  }

  render() {
    const { inlineLabel, configurationModel, campaignsListUrl, includeNone } = this.props;
    const modeOptions = includeNone ? MODE_OPTIONS.concat(NONE_OPTION) : MODE_OPTIONS;

    return (
      <div className={classNames("campaign-selector", { "campaign-selector--inline-label": inlineLabel })}>
        <label className="campaign-selector__label">Apply this for</label>
        <div className='campaign-selector__selectors'>
          <Select2
            uniqueNameField='campaign_selector_mode'
            friendlyNameField='campaign_selector_mode'
            node={configurationModel}
            values={modeOptions}
            allowSearch={false}
            changeListener={this.updateSelectorMode.bind(this)}
            inline={true}
          />
          {!_.includes(['all', 'none'], this.state.selectorMode) &&
          <MultiSelectFilter
            name="select-campaigns"
            url={campaignsListUrl}
            initialItems={configurationModel.get('selected_campaigns')}
            open={!this.state.initialRender}
            title="Campaigns"
            hideLabel={true}
            hideTitlePrefix={true}
            noLimit={true}
            isReportFilter={false}
            onApply={this.updateSelectedCampaigns}
            onBlur={this.updateSelectedCampaigns}
            hideActionButtons={true} />}
        </div>
      </div>
    );
  }
}

CampaignSelector.propTypes = {
  configurationModel: PropTypes.object.isRequired,
  campaignsListUrl:   PropTypes.string.isRequired,
  includeNone:        PropTypes.bool,
  inlineLabel:        PropTypes.bool
};

CampaignSelector.defaultProps = {
  includeNone: false,
  inlineLabel: true
};

export default CampaignSelector;
